import allucentlogo from "./assets/White Lucent AI.png";
export const brandingSettings = {
  primaryColor: '#F8991C',
  secondaryColor: '#320857',
  textcolorPrimary: "#212121",
  textcolorSecondary: "#999",
  headercolor: "#7E678B",
  logoPath: allucentlogo,

  primaryColorDark: "#fd5f07b3",
  secondaryColorDark: '#fd5f07b3',
  textcolorPrimaryDark: "#aaa",
  textcolorSecondaryDark: "#fff",
  headercolorDark: "#010101",
  baseFont: "Inter",
  baseFontSize: 14,
  bodyFontSize: 14,
};